import { Button, Position, Tooltip } from "@blueprintjs/core";
import { action, flow, observable } from "mobx";
import { observer } from "mobx-react";
import React from "react";

import DisableFS from "../../assets/icons/fullscreen-disable.inline.svg";
import EnableFS from "../../assets/icons/fullscreen-enable.inline.svg";
import styles from "./FullScreenButton.module.css";

interface FullScreenButtonProps {
    containerEl?: HTMLElement | null;
}

@observer
export default class FullScreenButton extends React.PureComponent<FullScreenButtonProps> {
    public static displayName = "FullScreenButton";

    @observable public isEnabled = false;

    public componentDidMount() {
        if (typeof document !== "undefined") {
            document.addEventListener("fullscreenchange", this.handleFullscreenChange);
        }
    }

    public componentWillUnmount() {
        if (typeof document !== "undefined") {
            document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
        }
    }

    public render() {
        if (this.props.containerEl == null) {
            return null;
        }

        return (
            <Tooltip className={styles.container} content="Toggle fullscreen" position={Position.LEFT}>
                <Button onClick={this.handleClick} large={true} minimal={true}>
                    {this.isEnabled ? <DisableFS /> : <EnableFS />}
                </Button>
            </Tooltip>
        );
    }

    private handleClick = () => {
        this.toggleFullscreen();
    };

    private toggleFullscreen = flow(function* (this: FullScreenButton) {
        if (this.isEnabled) {
            document.exitFullscreen();
        } else if (this.props.containerEl != null) {
            yield this.props.containerEl.requestFullscreen();
            try {
                // trigger DanceFloor top section to resize
                window.dispatchEvent(new Event("resize"));
            } catch {
                // ignore
            }
        }
    });

    @action
    private handleFullscreenChange = () => {
        this.isEnabled = !this.isEnabled;
    };
}
